import * as React from 'react'
import Table from '@components/table/table'
import { ProductPackage, ProductPackageKind } from '@modules/product-package/models'
import { StatusBadge } from '@modules/promotions/common/status-badge'
import { toDefaultDateTimeFormat } from '@helpers/date-helper'
import { useSellers } from '@components/hooks/use-grouped-sellers'
import { formatPrice, getById } from '@helpers/utils'
import { useReportsAppData } from '@modules/reports/hooks/use-reports-app-data'
import { useDetailsModal } from '@components/hooks/use-details-modal'
import { NavigationPath } from '@models/routes'
import { ProductPackageSet } from '@models/products'

interface Props {
  transaction: ProductPackage
  index: number
  productPackageSets: ProductPackageSet[]
  productPackageKind: ProductPackageKind
}

export const EndlessHolidayTransactionsTableRow = ({
  transaction,
  index,
  productPackageSets,
  productPackageKind,
}: Props): React.ReactNode => {
  const { sources } = useReportsAppData()

  const { handleClientDetails } = useDetailsModal(
    ['EndlessHolidayDetailsModal', { product: transaction }],
    NavigationPath.ProductPackage,
    NavigationPath.ProductPackageWithParams,
    transaction.id,
  )

  const sellers = useSellers()
  const source = getById(sources, transaction.source_marketing)
  const seller = getById(sellers, transaction.seller)
  const productPackageSet = getById(productPackageSets, transaction.product_package_set)

  return (
    <Table.Row onClick={handleClientDetails} className="cursor-pointer">
      <Table.Cell className="align-middle">{index + 1}.</Table.Cell>
      <Table.Cell className="align-middle">{transaction.number}</Table.Cell>
      <Table.Cell className="align-middle">
        <span>{transaction.client.name}</span> <br />
        <small>{transaction.client.email}</small>
      </Table.Cell>
      <Table.Cell className="align-middle">
        <StatusBadge element={transaction} />
      </Table.Cell>
      <Table.Cell className="align-middle">{productPackageSet?.name}</Table.Cell>
      <Table.Cell className="align-middle">{formatPrice(transaction.subscription_total_price_brutto)}</Table.Cell>
      {productPackageKind === 'endless_holiday' && (
        <>
          <Table.Cell className="align-middle">{formatPrice(transaction.subscription_total_deposit)}</Table.Cell>
          <Table.Cell className="align-middle">{formatPrice(transaction.gastro_card_total_price_brutto)}</Table.Cell>
        </>
      )}
      <Table.Cell className="align-middle">{seller?.name ?? '-'}</Table.Cell>
      <Table.Cell className="align-middle">{source?.name}</Table.Cell>
      <Table.Cell className="align-middle">{toDefaultDateTimeFormat(transaction.created)}</Table.Cell>
      <Table.Cell style={{ width: 40 }} className="align-middle">
        <i className="uil-eye font-14 lh-1 cursor-pointer" />
      </Table.Cell>
    </Table.Row>
  )
}
